import { config } from 'src/config/config'
import { apiCall } from 'src/utils/networking'

export const api = {
  getTrendingTasks: async () =>
    apiCall(`${config.baseAPIUrl}/task/trending/`, {
      method: 'POST',
    }),
}
